import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  title: {
    color: "#030F1C",
    fontFamily: "Inter Tight !important",
    fontWeight: "500 !important",
    fontSize: "22px !important",
    lineHeight: "32px !important",
  },
  subtitle: {
    color: "#030F1C",
    fontFamily: "Inter Tight !important",
    fontWeight: "400 !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    marginTop: "8px !important",
  },
  notiTitle: {
    color: "#030F1C",
    fontFamily: "Inter Tight !important",
    fontWeight: "500 !important",
    fontSize: "18px !important",
    lineHeight: "24px !important",
    paddingBottom: "20px !important",
  },
  name: {
    color: "#202939",
    fontFamily: "Inter Tight !important",
    fontWeight: "500 !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
  },
}));
export default useStyles;
